import { z } from 'zod';
import { ArtifactSchema } from '../../entities/artifact/artifact.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Update Artifact Request Schema
 * PATCH /api/v2/artifacts/:id
 */ export const UpdateArtifactRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    description: z.string().optional(),
    type: z.string().optional(),
    fileUrl: z.string().optional(),
    size: z.number().optional(),
    mimeType: z.string().optional()
});
/**
 * Update Artifact Response Schema
 * PATCH /api/v2/artifacts/:id
 */ export const UpdateArtifactResponseSchema = z.object({
    data: ArtifactSchema
});

//# sourceMappingURL=update-artifact.schema.js.map